import { useLayoutEffect, useState } from "react";

import { isMobile } from "@/utils/media-query";

export default function useWindowSize() {
  const [size, setSize] = useState([0, 0]);
  const [isSp, setIsSp] = useState<boolean>(isMobile());
  useLayoutEffect(() => {
    const updateSize = (): void => {
      setSize([window.innerWidth, window.innerHeight]);
      setIsSp(isMobile());
    };

    window.addEventListener("resize", updateSize);
    updateSize();

    return () => window.removeEventListener("resize", updateSize);
  }, []);
  const [width, height] = size;
  return {
    width,
    height,
    isSp,
  };
}
